import React from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { BarChart3, Layers, CreditCard, TrendingDown } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function FeatureCards() {
  const navigate = useNavigate();
  const features = [
    {
      icon: <BarChart3 className="h-5 w-5 text-[#59266D] md:h-6 md:w-6" />,
      title: "Check loan rate and eligibility",
      description:
        "Know the amount you qualify for from top banks, Without impacting your credit score",
      cta: "Check My Rate",
      color: "#59266D",
      naviLink: "/check-rate-landing-page",
    },
    {
      icon: <Layers className="h-5 w-5 text-[#59266D] md:h-6 md:w-6" />,
      title: "Predict approval chances",
      description:
        "Know where you stand before applying — with our insights and score-matching logic.",
      cta: "Get My Chances",
      color: "#59266D",
      naviLink: "/loan-approval-chances",
    },
    {
      icon: <CreditCard className="h-5 w-5 text-[#59266D] md:h-6 md:w-6" />,
      title: "View credit score and running loans",
      description:
        "Get a full view of your credit score and running loans from all banks in seconds.",
      cta: "View My Active Loans",
      color: "#59266D",
      naviLink: "/running-loan-page",
    },
    {
      icon: <TrendingDown className="h-5 w-5 text-[#59266D] md:h-6 md:w-6" />,
      title: "Check EMI savings & top up offers",
      description:
        "Explore options to save on EMIs or get extra funds with ease.",
      cta: "Check EMI Saving",
      color: "#59266D",
      naviLink: "/lower-emi-page",
    },
  ];

  return (
    <section className="bg-[#f0f0f5] pt-10 md:pt-16 lg:pt-20 pb-12 md:pb-20 lg:pb-24">
      <div className="container px-3 px-md-6">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(2, 1fr)",
              lg: "repeat(4, 1fr)",
            },
            gap: { xs: "1.5rem", md: "1rem" },
          }}
        >
          {features.map((feature, index) => (
            <Card
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                borderRadius: "24px",
                boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                "&:hover": {
                  boxShadow: "0 8px 25px rgba(0,0,0,0.12)",
                },
                transition: "box-shadow 0.3s",
                border: "none",
                backgroundColor: "white",
              }}
            >
              <Box sx={{ p: { xs: 2.5, md: 2.4 } }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",

                    alignItems: "center",
                    mb: { xs: 1.5, md: 0 },
                  }}
                >
                  <div className="mr-4 bg-[#59266D]/10 p-2 flex items-center justify-center rounded-full w-9 h-9 md:w-9 md:h-9 mt-0.5">
                    {feature.icon}
                  </div>

                  <div className="text-base md:text-lg lg:text-xl font-semibold">
                    {feature.title}
                  </div>
                </Box>
              </Box>

              <CardContent sx={{ flexGrow: 1, py: 0, px: { xs: 2.5, md: 3 } }}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    textAlign: "start",
                    fontSize: { xs: "0.75rem", md: "0.875rem" },
                    fontFamily: "Archivo",
                    fontWeight: 500,
                    letterSpacing: "0.025em",
                  }}
                >
                  {feature.description}
                </Typography>
              </CardContent>

              <CardActions sx={{ p: { xs: 2.5, md: 3 }, pt: 1 }}>
                <Button
                  fullWidth
                  variant="contained"
                  sx={{
                    borderRadius: "9999px",
                    backgroundColor: feature.color,
                    "&:hover": {
                      backgroundColor: "rgba(89, 38, 109, 0.9)",
                    },
                    fontSize: { xs: "0.75rem", md: "0.875rem" },
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    textTransform: "none",
                    fontFamily: "Archivo",
                  }}
                  onClick={() => {
                    navigate(feature.naviLink);
                  }}
                >
                  {feature.cta}
                </Button>
              </CardActions>
            </Card>
          ))}
        </Box>
      </div>
    </section>
  );
}
